import { POST_AUTOMATED_REPORT_FAILURE, POST_AUTOMATED_REPORT_REQUEST, POST_AUTOMATED_REPORT_SUCCESS, PostAutomatedReportActionTypes, PostAutomatedReportState } from './types';

const defaultState: PostAutomatedReportState = {
  isLoading: false,
  errorMessage: "",
};

export default function postAutomatedReport(state = defaultState, action: PostAutomatedReportActionTypes): PostAutomatedReportState {
  switch (action.type) {
    case POST_AUTOMATED_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case POST_AUTOMATED_REPORT_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case POST_AUTOMATED_REPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
